// src/pages/ConfidentialitePage.jsx
import React from 'react';
import LegalLayout from '../components/LegalLayout';
import Seo from '../components/Seo';

const ConfidentialitePage = () => {
  const articles = [
    {
      title: '1. Introduction',
      content: `
        <p>La présente Politique de Confidentialité a pour objet de vous informer sur la manière dont YAQAM collecte, utilise et protège vos données personnelles lorsque vous utilisez notre service de planification de repas assistée par YAQAM.</p>
        <p class="mt-2">Nous nous engageons à respecter votre vie privée et à protéger les informations que vous nous communiquez conformément au Règlement Général sur la Protection des Données (RGPD) et à la loi Informatique et Libertés.</p>
      `
    },
    {
      title: '2. Données collectées',
      content: `
        <h3 class="text-lg font-medium mt-4 mb-2" style="color: #2C3E50">2.1 Données d'inscription</h3>
        <ul class="list-disc pl-5 space-y-1">
          <li>Nom et prénom</li>
          <li>Adresse email</li>
          <li>Mot de passe sécurisé (stocké sous forme cryptée)</li>
        </ul>
        
        <h3 class="text-lg font-medium mt-4 mb-2" style="color: #2C3E50">2.2 Données de profil</h3>
        <ul class="list-disc pl-5 space-y-1">
          <li>Préférences alimentaires (régimes, allergies, ingrédients non appréciés)</li>
          <li>Objectifs nutritionnels</li>
          <li>Composition du foyer (nombre de personnes, présence d'enfants)</li>
        </ul>
        
        <h3 class="text-lg font-medium mt-4 mb-2" style="color: #2C3E50">2.3 Données d'utilisation</h3>
        <ul class="list-disc pl-5 space-y-1">
          <li>Plans de repas générés</li>
          <li>Listes de courses</li>
          <li>Historique des commandes au drive</li>
          <li>Feedback sur les recettes</li>
        </ul>
        
        <h3 class="text-lg font-medium mt-4 mb-2" style="color: #2C3E50">2.4 Données techniques</h3>
        <ul class="list-disc pl-5 space-y-1">
          <li>Adresse IP</li>
          <li>Type et version du navigateur</li>
          <li>Système d'exploitation</li>
          <li>Horodatage des connexions</li>
          <li>Pages visitées et actions effectuées</li>
        </ul>
        
        <h3 class="text-lg font-medium mt-4 mb-2" style="color: #2C3E50">2.5 Données de paiement</h3>
        <p>Pour les utilisateurs premium, nous collectons des informations de paiement via notre prestataire de paiement sécurisé. YAQAM ne stocke pas directement vos informations bancaires.</p>
      `
    },
    {
      title: '3. Finalités du traitement',
      content: `
        <p>Nous utilisons vos données personnelles pour les finalités suivantes :</p>
        
        <h3 class="text-lg font-medium mt-4 mb-2" style="color: #2C3E50">3.1 Fourniture du service</h3>
        <ul class="list-disc pl-5 space-y-1">
          <li>Création et gestion de votre compte</li>
          <li>Personnalisation des plans de repas selon vos préférences</li>
          <li>Génération de listes de courses</li>
          <li>Transmission des commandes aux services de drive partenaires</li>
        </ul>
        
        <h3 class="text-lg font-medium mt-4 mb-2" style="color: #2C3E50">3.2 Amélioration du service</h3>
        <ul class="list-disc pl-5 space-y-1">
          <li>Analyse des usages pour améliorer nos algorithmes de YAQAM</li>
          <li>Développement de nouvelles fonctionnalités</li>
          <li>Résolution des problèmes techniques</li>
        </ul>
        
        <h3 class="text-lg font-medium mt-4 mb-2" style="color: #2C3E50">3.3 Communication</h3>
        <ul class="list-disc pl-5 space-y-1">
          <li>Envoi d'informations relatives au service</li>
          <li>Réponse à vos demandes d'assistance</li>
          <li>Envoi de newsletters (avec votre consentement)</li>
        </ul>
        
        <h3 class="text-lg font-medium mt-4 mb-2" style="color: #2C3E50">3.4 Fins commerciales et marketing</h3>
        <ul class="list-disc pl-5 space-y-1">
          <li>Envoi d'offres personnalisées (avec votre consentement)</li>
          <li>Réalisation d'études statistiques anonymisées</li>
        </ul>
      `
    },
    {
      title: '4. Base juridique du traitement',
      content: `
        <p>Le traitement de vos données personnelles est fondé sur :</p>
        <ul class="list-disc pl-5 space-y-1 mt-2">
          <li>L'exécution du contrat qui nous lie (fourniture du service YAQAM)</li>
          <li>Votre consentement (pour l'envoi de communications marketing)</li>
          <li>Notre intérêt légitime (amélioration de nos services, sécurité)</li>
          <li>Le respect de nos obligations légales</li>
        </ul>
      `
    },
    {
      title: '5. Destinataires des données',
      content: `
        <p>Vos données personnelles peuvent être transmises aux destinataires suivants :</p>
        
        <h3 class="text-lg font-medium mt-4 mb-2" style="color: #2C3E50">5.1 En interne</h3>
        <ul class="list-disc pl-5 space-y-1">
          <li>Notre personnel autorisé (service client, développement, marketing)</li>
        </ul>
        
        <h3 class="text-lg font-medium mt-4 mb-2" style="color: #2C3E50">5.2 Sous-traitants</h3>
        <ul class="list-disc pl-5 space-y-1">
          <li>Hébergeur du site et des serveurs</li>
          <li>Prestataire de paiement sécurisé</li>
        </ul>
        
        <h3 class="text-lg font-medium mt-4 mb-2" style="color: #2C3E50">5.3 Partenaires</h3>
        <ul class="list-disc pl-5 space-y-1">
          <li>Services de drive (uniquement les données nécessaires à la commande, avec votre consentement)</li>
        </ul>
        
        <h3 class="text-lg font-medium mt-4 mb-2" style="color: #2C3E50">5.4 Tiers autorisés</h3>
        <ul class="list-disc pl-5 space-y-1">
          <li>Autorités judiciaires ou administratives (sur réquisition légale)</li>
        </ul>
      `
    },
    {
      title: '6. Durée de conservation',
      content: `
        <p>Nous conservons vos données personnelles pour la durée strictement nécessaire aux finalités poursuivies, à savoir :</p>
        <ul class="list-disc pl-5 space-y-1 mt-2">
          <li>Données de compte et de profil : pendant toute la durée de votre inscription, puis 3 ans après votre dernière activité</li>
          <li>Données de commande : 10 ans (obligations comptables et fiscales)</li>
          <li>Données de navigation : 13 mois maximum</li>
          <li>Données de paiement : durée de la relation contractuelle, puis archivage selon les obligations légales</li>
        </ul>
      `
    },
    {
      title: '7. Sécurité des données',
      content: `
        <p>Nous mettons en œuvre des mesures techniques et organisationnelles appropriées pour protéger vos données personnelles contre la destruction, la perte, l'altération ou l'accès non autorisé, notamment :</p>
        <ul class="list-disc pl-5 space-y-1 mt-2">
          <li>Cryptage des données sensibles</li>
          <li>Authentification à deux facteurs pour l'accès aux systèmes internes</li>
          <li>Accès limité aux données selon les besoins</li>
          <li>Audits de sécurité réguliers</li>
          <li>Formation de notre personnel à la protection des données</li>
        </ul>
      `
    },
    {
      title: '8. Vos droits',
      content: `
        <p>Conformément à la réglementation applicable, vous disposez des droits suivants sur vos données personnelles :</p>
        <ul class="list-disc pl-5 space-y-1 mt-2">
          <li>Droit d'accès</li>
          <li>Droit de rectification</li>
          <li>Droit à l'effacement (droit à l'oubli)</li>
          <li>Droit à la limitation du traitement</li>
          <li>Droit à la portabilité</li>
          <li>Droit d'opposition</li>
          <li>Droit de retirer votre consentement à tout moment</li>
          <li>Droit de définir des directives relatives au sort de vos données après votre décès</li>
        </ul>
        <p class="mt-2">Pour exercer ces droits, vous pouvez nous contacter par email à <a href="mailto:info@j7lab.com" style="color: #87A96B" class="hover:opacity-80">info@j7lab.com</a> ou par courrier à l'adresse de notre siège social.</p>
      `
    },
    {
      title: '9. Transferts internationaux de données',
      content: `
        <p>Vos données personnelles sont principalement traitées au sein de l'Union Européenne. Si nous devions transférer vos données hors de l'UE, nous nous assurerions que ce transfert soit encadré par des garanties appropriées (clauses contractuelles types de la Commission européenne, pays bénéficiant d'une décision d'adéquation, etc.).</p>
      `
    },
    {
      title: '10. Cookies et technologies similaires',
      content: `
        <p>Notre site utilise des cookies et technologies similaires pour améliorer votre expérience utilisateur, analyser notre trafic et personnaliser le contenu. Pour plus d'informations, veuillez consulter notre Politique de Cookies accessible <a href="#" style="color: #87A96B" class="hover:opacity-80">ici</a>.</p>
      `
    },
    {
      title: '11. Modifications de la Politique de Confidentialité',
      content: `
        <p>Nous nous réservons le droit de modifier la présente Politique de Confidentialité à tout moment. La version en vigueur est celle publiée sur notre site. En cas de modifications substantielles, nous vous en informerons par email ou via une notification sur notre site.</p>
      `
    },
    {
      title: '12. Contact et réclamations',
      content: `
        <p>Pour toute question relative à la présente Politique de Confidentialité ou pour toute demande concernant vos données personnelles, vous pouvez nous contacter :</p>
        <ul class="list-disc pl-5 space-y-1 mt-2">
          <li>Par email : <a href="mailto:info@j7lab.com" style="color: #87A96B" class="hover:opacity-80">info@j7lab.com</a></li>
          <li>Par courrier : [adresse du siège social]</li>
        </ul>
        <p class="mt-2">Si vous estimez, après nous avoir contactés, que vos droits ne sont pas respectés, vous pouvez adresser une réclamation à la CNIL (<a href="https://www.cnil.fr" target="_blank" style="color: #87A96B" class="hover:opacity-80">www.cnil.fr</a>).</p>
      `
    }
  ];

  return (
    <>
      <Seo
        title="Politique de Confidentialité"
        description="Découvrez comment YAQAM collecte, protège et utilise vos données personnelles."
        breadcrumb
        noindex
      />
      <LegalLayout title="Politique de Confidentialité">
      <div className="space-y-8">
        {articles.map((article, index) => (
          <div key={index} className="border-b border-gray-100 pb-6 last:border-0 last:pb-0">
            <h2 className="text-xl font-semibold mb-4" style={{ color: '#2C3E50' }}>{article.title}</h2>
            <div 
              style={{ color: '#6c757d' }}
              dangerouslySetInnerHTML={{ __html: article.content }}
            />
          </div>
        ))}
      </div>
      </LegalLayout>
    </>
  );
};

export default ConfidentialitePage;
